import { faqsTypes } from "./faqTypes";
import { faqsApi } from "./faqApi"; 

const onChange = (field, value) => {
  
  return dispatch => {
    dispatch({
      type: faqsTypes.FAQ_ONCHANGE,
      payload: { prop: field, value: value },
    });
  };
};

const onGetFaqCategories = () => async dispatch => {
    let response = await faqsApi.getFaqCategories();
    return response;
  };

const onGetAllFaqs = (payload) =>async dispatch => {
    let response = await faqsApi.getAllFaqs(payload);
    return response;
  };

  const onAddUpdateFaq = (payload) =>async dispatch => {
    let response = await faqsApi.addUpdateFaq(payload);
    return response;
  };

  const onGetFaqById = (payload) =>async dispatch => {
    let response = await faqsApi.getFaqById(payload);
    return response;
  };

  const onDeleteFaq = (payload) =>async dispatch => {
    let response = await faqsApi.deleteFaq(payload);
    return response;
  };

  const selectFaq = (faq) => async (dispatch) => {
    dispatch({
      type: faqsTypes.SELECTED_FAQS,
      payload: faq,
    });
};

const selectAllFaqs = (faqs) => async (dispatch) => {
  dispatch({
    type: faqsTypes.ALL_SELECTED_FAQS,
    payload:[ ...faqs],
  });
};


  export const faqsActions = {
    onGetFaqCategories:onGetFaqCategories,
    onGetAllFaqs:onGetAllFaqs,
    onAddUpdateFaq:onAddUpdateFaq,
    onGetFaqById:onGetFaqById,
    onDeleteFaq:onDeleteFaq,
    selectFaq:selectFaq,
    selectAllFaqs:selectAllFaqs,
  }
